import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardNormativesEdit = guard(groupRights.Normatives)('edit');
export const guardNormativesWatch = guard(groupRights.Normatives)('watch');
export const guardNormativesCreate = guard(groupRights.Normatives)('create');
